import React from 'react'
import PropTypes from 'prop-types'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'
import AspectRatioImagePlaceholder from 'src/ui/AspectRatioImage/AspectRatioImagePlaceholder'
import CardInfoSkeleton from 'src/ui/Card/subcomponents/CardInfoSkeleton'

import HeroCardReferencePlaceholder from './subcomponents/HeroCardReference/HeroCardReferencePlaceholder'
import HeroCardSkeleton from './HeroCardSkeleton'

const HeroCardPlaceholder = ({ aspectRatio, hasReference }) => {
  return (
    <HeroCardSkeleton
      imageSection={
        <AspectRatioImagePlaceholder
          aspectRatio={aspectRatio}
          borderRadius="1x"
        />
      }
      infoSection={
        <CardInfoSkeleton
          labelSection={
            <LoadingBox width={100} maxWidth="100%">
              &nbsp;
            </LoadingBox>
          }
          titleSection={
            <LoadingBox width={200} maxWidth="100%">
              &nbsp;
            </LoadingBox>
          }
        />
      }
      referenceSection={hasReference && <HeroCardReferencePlaceholder />}
    />
  )
}

HeroCardPlaceholder.propTypes = {
  aspectRatio: PropTypes.string,
  hasReference: PropTypes.bool,
}

export default HeroCardPlaceholder
